import apiHttpClient from "./ApiHttpService";

export default class AccountService {
  loginWithDevice(employeeId, deviceId) {
    return apiHttpClient.post(`Account/loginWithDevice`, {
      employeeId,
      deviceId,
    });
  }
  login(employee, password) {
    return apiHttpClient.post(`Account/login`, {
      employee,
      password,
    });
  }
  isEmployeeActive(employeeId){
    return apiHttpClient.get(`Account/isEmployeeActive?employeeId=${employeeId}`);
  }
  updateEmployeeSetting(name, value) {
    return apiHttpClient.put(`Account/updateEmployeeSetting`, {
      name,
      value,
    });
  }
  resetPassword(email) {
    return apiHttpClient.post("Account/resetPassword", { email: email });
  }
  changePassword(email, password, token) {
    return apiHttpClient.post("Account/changePassword", { email: email, password: password, token: token });
  }
}
